export const installMenu = () => {
  const navTriggerWrap = document.querySelector('.navTrigger-wrap');
  const menuWrap = document.querySelector('.menu-wrap');
  const menuItems = document.querySelectorAll('.primary-menu a'); // Select menu links

  if (navTriggerWrap && menuWrap) {
    const navTrigger = navTriggerWrap.querySelector('.navTrigger');

    navTriggerWrap.addEventListener('click', () => {
      navTrigger.classList.toggle('active');
      menuWrap.classList.toggle('active');
    });

    // Add event listener to each menu item
    menuItems.forEach((item) => {
      item.addEventListener('click', () => {
        menuWrap.classList.remove('active');
        navTrigger.classList.remove('active');
      });
    });
  }
};
